import { useEffect, useState } from 'react';

/**
 * Igual que `value`, pero al pasar de true a false espera `delayMs` antes
 * de propagarlo. Se usa para que el checklist no reaparezca de golpe justo
 * cuando un modal empieza a cerrarse.
 */
export function useDelayedFalse(value: boolean, delayMs: number): boolean {
  const [delayed, setDelayed] = useState(value);

  useEffect(() => {
    if (value) {
      setDelayed(true);
      return;
    }
    const timer = window.setTimeout(() => setDelayed(false), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return delayed;
}
